import React, { useState } from "react";
import "./ContactForm.css";

function ContactForm() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });
  const [result, setResult] = useState("");

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      access_key: "9faddccf-b22b-4ec1-9606-07ae2a3fb87f",
      name: formData.name,
      email: formData.email,
      message: formData.message,
    };

    try {
      const res = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const data = await res.json();
      if (data.success) {
        setResult("Message sent successfully!");
        setFormData({ name: "", email: "", message: "" });
      } else {
        setResult("Failed to send message. Try again.");
      }
    } catch (err) {
      console.error(err);
      setResult("Error occurred. Try again.");
    }

    setTimeout(() => setResult(""), 5000);
  };

  return (
    <div className="contact-container">
      <div className="contact-box">
        <h1>Contact Me</h1>
        <p>Fill out the form below and I will get back to you soon.</p>
        <form onSubmit={handleSubmit}>
          <label>Name</label>
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            required
          />

          <label>Email</label>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
          />

          <label>Message</label>
          <textarea
            name="message"
            value={formData.message}
            onChange={handleChange}
            rows="5"
            required
          ></textarea>

          <button type="submit">Send Message</button>
        </form>
        {result && <div id="result">{result}</div>}
      </div>
    </div>
  );
}

export default ContactForm;
